import { useStoreState } from "easy-peasy";
import React, { useState } from "react";
import { PRODUCT } from "../../../models/websiteTypesConstants";

export default function SocialProofPopup() {

  const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
  const [displayMessage, setDisplayMessage] = useState(true);
  
  return (<>{
    (displayMessage && brandSettings.ProductName !== PRODUCT.Grand.bank) && (
    <div style={{backgroundColor:"#2ecc71", color:"white", width: "max-content", padding: "8px", border: "2px solid black", borderRadius: "8px", position:"relative", zIndex: "10"}}>
      <span role="img" aria-label="smile face">😊</span> Join the millions of <b>Happy Customers!</b>
      <button onClick={() => setDisplayMessage(false)}
        style={{
          top: '-50%',
          position: 'absolute',
          color:"white",
          background: 'black',
          borderRadius: '100%',
        }}>x</button>
    </div>
    )
  }</>);
}